import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import jaCommon from "../locales/ja/common.json";
import jaErrors from "../locales/ja/errors.json";
import enCommon from "../locales/en/common.json";
import enErrors from "../locales/en/errors.json";
import koCommon from "../locales/ko/common.json";
import koErrors from "../locales/ko/errors.json";

export const defaultNS = "common";
export const resources = {
  ja: { common: jaCommon, errors: jaErrors },
  en: { common: enCommon, errors: enErrors },
  ko: { common: koCommon, errors: koErrors },
} as const;

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: "ja",
    fallbackLng: "ja",

    defaultNS,
    ns: [ "common", "errors" ],
    interpolation: {
      escapeValue: false, // Reactは基本的にXXXを塞いでるのでfalse
    },
});

export default i18n;